import { AudioManager } from "../../../AudioManager";
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";
import * as Mahjong from "@ravalmatic/mahjong-engine";
import { SplashScene } from "../SplashScene";
import { BoardInfoContainer as BoardInfoContainer } from "./BoardInfoContainer";
import { CategoriesContainer } from "./CategoriesContainer";

export class CategoryLayer extends Phaser.GameObjects.Container {

    public static currentInstance: CategoryLayer;

    public static readonly CATEGORIES = ["Plants", "Buildings", "Pyramids", "Animals", "Symbols", "Zodiac", "Letters", "Classic", "Things", "Forms"];

    public maskRect: Phaser.Geom.Rectangle;
    public scrolling: boolean;

    private areaRec: Phaser.Geom.Rectangle;
    private scrollingContainer: Phaser.GameObjects.Container;
    
    constructor(scene: Phaser.Scene, category: string) {
        
        super(scene);

        CategoryLayer.currentInstance = this;

        const gameText = this.scene.cache.json.get("text");
        const lan = GameVars.gameData.data.language;

        this.scrolling = true;

        this.scene.time.delayedCall(600, () => {
            this.scrolling = false;
        }, [], this);

        const darkLayer = new Phaser.GameObjects.Graphics(scene);
        darkLayer.fillStyle(0x2c241f, .5);
        darkLayer.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        this.add(darkLayer);

        const scaledItemsContainer = new Phaser.GameObjects.Container(scene);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2 + 30;
        scaledItemsContainer.scaleX = GameVars.scaleX;
        this.add(scaledItemsContainer);
        
        const background = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "category-background");
        scaledItemsContainer.add(background);

        const categoryTitleBackground = new Phaser.GameObjects.Image(this.scene, -490, -315, "texture_atlas_1", "tab_boards_daily_games");
        categoryTitleBackground.setOrigin(0);
        scaledItemsContainer.add(categoryTitleBackground);

        const index = CategoryLayer.CATEGORIES.indexOf(category) + 1;

        const categoryImg = new Phaser.GameObjects.Image(scene, categoryTitleBackground.x + 35, categoryTitleBackground.y + 35, "texture_atlas_1", "icon_" + index);
        scaledItemsContainer.add(categoryImg);

        const key = CategoriesContainer.CATEGORIES_DATA[index - 1].key;

        let categoryStr = gameText[key][lan];
        categoryStr = categoryStr.charAt(0).toUpperCase() + categoryStr.slice(1).toLowerCase();

        const categoryLabel = new Phaser.GameObjects.Text(scene, categoryTitleBackground.x + 68, categoryTitleBackground.y + 38, categoryStr.toUpperCase(), {fontFamily: "OpenSans-CondLight", fontSize: "42px", color: "#644329"});
        categoryLabel.setOrigin(0, .5);
        scaledItemsContainer.add(categoryLabel);

        const n = GameVars.gameData.categoriesData[category].n;

        let numUnlocked = 0;

        for (let i = 0; i < GameVars.gameData.categoriesData[category].levelsData.length; i++) {

            if (GameVars.gameData.categoriesData[category].levelsData[i].time !== null) {
                numUnlocked++;
            }
        }

        const quantitiesLabel = new Phaser.GameObjects.Text(scene, categoryLabel.x + categoryLabel.width + 5, categoryLabel.y + 2, "(" + numUnlocked + "/" + n + ")", {fontFamily: "OpenSans-CondLight", fontSize: "32px", color: "#644329"});
        quantitiesLabel.setOrigin(0, .5);
        scaledItemsContainer.add(quantitiesLabel);

        this.scrollingContainer = new Phaser.GameObjects.Container(scene);
        scaledItemsContainer.add(this.scrollingContainer);

        let w = 1000 * GameVars.scaleX;
        let h = 550;

        this.maskRect = new Phaser.Geom.Rectangle(GameConstants.GAME_WIDTH / 2 - w / 2, GameConstants.GAME_HEIGHT / 2 - h / 2 + 65, w, h);

        const maskShape = new Phaser.GameObjects.Graphics(this.scene);
        maskShape.fillStyle(0x00FF00);
        maskShape.fillRectShape(this.maskRect);
        
        this.scrollingContainer.mask = maskShape.createGeometryMask();

        const boardDataSorted: {boardData: Mahjong.BoardData, status: number} [] = [];

        for (let i = 0; i < GameVars.boardsData.length; i++) {

            if (GameVars.boardsData[i].cat === category) {
                boardDataSorted.push({boardData: GameVars.boardsData[i], status: 0});
            }
        }

        // estatus de los tableros
        // 0 no jugado
        // 1 jugado
        // 2 completado

        for (let i = 0; i < boardDataSorted.length; i++) {

            const boardData = boardDataSorted[i].boardData;

            let time = null;

            for (let j = 0; j < GameVars.gameData.categoriesData[category].levelsData.length; j++) {

                if (GameVars.gameData.categoriesData[category].levelsData[j].id === boardData.id) {
                    time = GameVars.gameData.categoriesData[category].levelsData[j].time;
                    break;
                }
            }

            if (time === null) {
                boardDataSorted[i].status = 0;
            } else if (time === 0) {
                boardDataSorted[i].status = 1;
            } else {
                boardDataSorted[i].status = 2;
            }
        }

        boardDataSorted.sort((a, b) => {

            return b.status - a.status;
        });

        for (let i = 0; i < boardDataSorted.length; i++) { 

            const boardInfoContainer = new BoardInfoContainer(scene, boardDataSorted[i]);
            boardInfoContainer.x = - 400 + (i % 5) * 200;
            boardInfoContainer.y = - 115 + Math.floor(i / 5) * 220;
            this.scrollingContainer.add(boardInfoContainer);
        }

        const lowerStripe = new Phaser.GameObjects.Image(scene, 0, 0, "texture_atlas_1", "mask_levels");
        lowerStripe.setOrigin(.5);
        lowerStripe.y = 284;
        lowerStripe.scaleX = 1010;
        scaledItemsContainer.add(lowerStripe);

        w = 1040 * GameVars.scaleX;
        h = 665;

        this.areaRec = new Phaser.Geom.Rectangle(GameConstants.GAME_WIDTH / 2 - w / 2, GameConstants.GAME_HEIGHT / 2 - h / 2 + 18, w, h);

        if (GameConstants.DEVELOPMENT) {

            const debugGraphics = new Phaser.GameObjects.Graphics(scene);
            debugGraphics.lineStyle(5, 0xff0000);
            debugGraphics.strokeRectShape(this.areaRec);
            this.add(debugGraphics);
        }

        this.scene.input.on("wheel", this.onWheel, this);
        this.scene.input.on("pointerdown", this.onPointerDown, this);

        this.alpha = 0;

        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            duration: 350
        });
    }

    public onWheel(pointer: Phaser.Input.Pointer, dx: any, dy: any, dz: any): void {

        if (this.scrolling) {
            return;
        }

        let delta_y: number = null;

        if (dz > 0) {
            delta_y = this.scrollingContainer.y === 0 ? 0 : 220;
        } else {
            delta_y = this.scrollingContainer.y === -220 * (Math.floor((this.scrollingContainer.length - 1) / 5) - 1) ? 0 : -220;
        }
        
        if (delta_y) {

            this.scrolling = true;

            this.scene.tweens.add({
                targets: this.scrollingContainer,
                y: this.scrollingContainer.y + delta_y,
                duration: 350,
                ease: Phaser.Math.Easing.Cubic.Out,
                onComplete: () => {
                    if (this.scene) {
                        this.scene.time.delayedCall(600, () => {
                            this.scrolling = false;
                        }, [], this);
                    }
                }
            });
        }
    }

    private onPointerDown(pointer: Phaser.Input.Pointer): void {

        if (this.alpha < 1) {
            return;
        }
            
        if (!this.areaRec.contains(pointer.x, pointer.y)) {

            this.scene.input.off("pointerdown", this.onPointerDown, this);
            this.scene.input.off("wheel", this.onWheel, this);

            this.scene.tweens.add({
                targets: this,
                alpha: 0,
                duration: 350,
                onComplete: () => {
                    SplashScene.currentInstance.hideCategoryLayer(); 
                }
            });

            AudioManager.playSound("btn_press");
        }
    }
}
